
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 睦邻-爱心求助，新增
 * @returns 
 */
export const post = (data): Promise<any> => {

    return axios.post(`${baseURL}/LoveHelp`, data);
}

/**
 * 睦邻-爱心求助，编辑
 * @returns 
 */
export const updateLoveHelp = (data: any): Promise<any> => {
    return axios.put(`${baseURL}/LoveHelp`, data);
}